<template>
  <v-card>
    <v-card-title>
      Parâmetros de Pesquisa
      <v-spacer />
      <json-c-s-v
        v-show="medias.length > 0"
        :data="medias"
        delimiter=";"
      >
        <v-btn
          color="cyan darken-3"
          dark
        >
          CSV
        </v-btn>
      </json-c-s-v>
      <json-excel
        v-show="medias.length > 0"
        :data="medias"
      >
        <v-btn
          color="cyan darken-3"
          dark
        >
          Excel
        </v-btn>
      </json-excel>
      <v-btn
        color="cyan darken-3"
        dark
        @click="search"
      >
        Pesquisar
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="filters.name"
            label="Veículo (Nome)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            v-model="filters.segments"
            label="Segmento Principal"
            multiple
            :items="segments"
            clearable
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="filters.mediaSources"
            label="Fonte"
            multiple
            :items="mediaSources"
            clearable
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="filters.employeesRanges"
            label="Número de Funcionários"
            multiple
            :items="employeesRanges"
            clearable
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            v-model="filters.hasEmail"
            label="Tem Email?"
            :items="yesNo"
            clearable
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="filters.hasSocial"
            label="Tem Redes Sociais?"
            :items="yesNo"
            clearable
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-select
            v-model="filters.regions"
            label="Região"
            multiple
            :items="regions"
            clearable
          />
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="filters.states"
            label="Estado"
            multiple
            :items="filteredStates"
            :disabled="filters.regions.length === 0"
            clearable
            @change="getCities"
          />
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="filters.cities"
            label="Cidade"
            multiple
            :items="cities"
            clearable
            :disabled="filters.states.length === 0"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import SegmentService from '../../../admin/js/services/SegmentService';
  import httpClient from '../../infra/httpClient';
  import CityService from '../../../admin/js/services/CityService';
  import StateService from '../../../admin/js/services/StateService';
  import RegionService from '../../../admin/js/services/RegionService';
  import JsonExcel from 'vue-json-excel';
  import JsonCSV from 'vue-json-csv';
  import MediaSourceService from '../../../admin/js/services/MediaSourceService';
  import EmployeesRangeService from '../../../admin/js/services/EmployeesRangeService';

  export default {
    components: {
      JsonExcel,
      JsonCSV
    },
    props: {
      medias: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    data: function () {
      return {
        defaultFilters: {
          name: null,
          mediaSources: [],
          segments: [],
          regions: [],
          states: [],
          cities: [],
          employeesRanges: [],
          hasEmail: null,
          hasSocial: null
        },
        filters: null,
        mediaSources: [],
        businessModels: [],
        employeesRanges: [],
        segments: [],
        features: [],
        regions: [],
        states: [],
        cities: [],
        yesNo: [{
            text: 'Sim',
            value: true
        },
        {
            text: 'Não',
            value: false
        }],
        mediaSourceService: new MediaSourceService('/api/v1/', httpClient),
        employeesRangeService: new EmployeesRangeService('/api/v1/', httpClient),
        segmentService: new SegmentService('/api/v1/', httpClient),
        cityService: new CityService('/api/v1/', httpClient),
        stateService: new StateService('/api/v1', httpClient),
        regionService: new RegionService('/api/v1', httpClient)
      };
    },
    computed: {
        filteredStates() {
          return this.states.filter((s) => {
            return this.filters.regions.find(v => v === s.region_id)
          });
        }
    },
    async beforeMount() {
      this.reset();
      this.mediaSources = await this.mediaSourceService.all();
      this.employeesRanges = await this.employeesRangeService.all();
      this.segments = await this.segmentService.all();
      this.regions = await this.regionService.all();
      this.states = await this.stateService.all();
    },
    methods: {
      search() {
        this.$emit('search', this.filters);
      },
      reset() {
        this.filters = { ...this.defaultFilters };
      },
      async getCities() {
        this.cities = await this.cityService.allByInState(this.filters.states)
      }
    }
  };
</script>

<style scoped>

</style>
